
const Form1 = ({ formState, nextHandler, changeHandler }) => {
  const gender = formState?.gender;
  const clickHandler = (gender) => {
    changeHandler({ gender: gender });
    nextHandler();
  }
  return(
    <div className="programsContainer programsContainer1">
        <div className="fo-26 bco text-center fw-700 mfo-22">Select your gender</div>

        <div className="row m-0 mt-4 genderSelection">
          <div name="gender" className="col-6 col-sm-6 m-auto text-center" onClick={() => clickHandler('Male')}>
            <div  className={`bmr_image m-auto ${gender === 'Male' ? 'active' : ''}`}>
              <img src={gender === 'Male' ? "/assets/men purple.png" : "/assets/men.png"} className="w-100 m-auto" alt="Gender Male"/>
            </div>
            <div className="text-center mt-3 blogCategoryTitle fw-600" >Male</div>
          </div>
          <div name="female" className="col-6 col-sm-6 m-auto text-center" onClick={() => clickHandler('Female')}>
            <div className={`bmr_image m-auto ${gender === 'Female' ? 'active' : ''}`}>
              <img src={gender === 'Female' ? "/assets/women purple.png" : "/assets/women.png"} className="w-100 m-auto" alt="Gender Female"/>
            </div>
            <div className="text-center mt-3 blogCategoryTitle fw-600">Female</div>
          </div>
        </div>
    </div>
  )
}

export default Form1;
